module.exports = __webpack_public_path__ + "media/application/media/images/Sign-Seal_Red_with_white-aeaddb75d190fd772e74a0dbc35d0897.png";